// Module
var code = "<ng-form> <kform-builder-option property=\"label\"></kform-builder-option> <kform-builder-option property=\"hideLabel\"></kform-builder-option> <kform-builder-option property=\"hidden\"></kform-builder-option> <kform-builder-option property=\"tableView\"></kform-builder-option> </ng-form> ";
// Exports
export default code;